import ContentComp from './Content';
export default ContentComp;
